{
	"API-Endpoint": "https://btctpbkyajfixlhsn2drseptim.appsync-api.us-east-2.amazonaws.com/graphql",
	"API-Key": "da2-6n4ajzdkrrhyzaf57ewef6g6q4",
	"IconStorage": "memorang-beta-icon",
	"IdentityPoolId": "us-east-2:2856c7f6-cb45-4b44-a890-9abea003aaea",
	"MediaStorage": "memorang-beta-media",
	"UpdateMergeFlagApi": "https://mfsnwzvsr0.execute-api.us-east-2.amazonaws.com/Prod/updateMergeFlag",
	"UserPoolClientId": "32kjm8uq0242uor0q6cj4u2ndk",
	"UserPoolClientIdWeb": "32kjm8uq0242uor0q6cj4u2ndk",
	"UserPoolClients": "{\"mobileClientScope\":[\"aws.cognito.signin.user.admin\",\"openid\"],\"mobileClientCallbackURLs\":[\"https://memorang.com/landing?loggedin=true\"],\"mobileClientLogoutURLs\":[\"https://memorang.com/landing/\"],\"webClientScope\":[\"aws.cognito.signin.user.admin\",\"openid\"],\"webClientCallbackURLs\":[\"https://memorang.com/dashboard\",\"http://localhost:3000/dashboard\"],\"webClientLogoutURLs\":[\"http://localhost:3000/signin\",\"https://memorang.com/signin\"]}",
	"UserPoolDomain": "psi-beta-user-pool.auth.us-east-2.amazoncognito.com",
	"UserPoolId": "us-east-2_XPLwAho9O",
	"Region": "us-east-2"
}
